import { render, staticRenderFns } from "./AssetPicker.vue?vue&type=template&id=bea9a7c4&scoped=true&"
import script from "./AssetPicker.vue?vue&type=script&lang=js&"
export * from "./AssetPicker.vue?vue&type=script&lang=js&"
import style0 from "./AssetPicker.vue?vue&type=style&index=0&id=bea9a7c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea9a7c4",
  null
  
)

export default component.exports